import styled from '@emotion/styled';
import { ApartmentOutlined, UserOutlined } from '@ant-design/icons';

export const BasicInfoCard = styled.div`
  background-color: ${props => props.theme.color.secondary};
  border-radius: 16px;
  box-shadow: 0 3px 8px ${props => props.theme.color.primary}33;
  color: ${props => props.theme.color.primary};
  margin-bottom: ${props => props.theme.spacing.md};
  padding: ${props => props.theme.spacing.md};
  width: 100%;
`;

export const AdviseeIcon = styled(UserOutlined)`
  color: ${props => props.theme.color.primary};
  font-size: 32px;
  margin-right: ${props => props.theme.spacing.regular};
`;

export const DependentIcon = styled(ApartmentOutlined)`
  color: ${props => props.theme.color.primary};
  font-size: 32px;
  margin-right: ${props => props.theme.spacing.regular};
`;

export const InfoText = styled.span`
  color: ${props => props.theme.color.primary};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeight[props.fontWeight || 'regular']};
  margin-right: ${props => props.theme.spacing.regular};
`;

export const FinancialValueText = styled.div`
  text-align: right;
  margin-right: ${props => props.theme.spacing.md};
`;

export const ExtraInfoText = styled.span`
  font-style: italic;
  font-weight: ${props => props.theme.fontWeight.light};
`;
